export function ModalBody({ className = "", children }) {
  return <div className={"lds-modal-body " + className}>{children}</div>;
}
